"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'fwk-proxyActionsToOwsGateway': {},
    'fwk-logOwsActionOptics_V2': {}
};
